import { Entity } from "../../helpers/Entity"
import RefundPayment, { RefundPaymentDto } from "./RefundPayment"

type RefundPaymentsAttributes = {
    //this includes declined amount
    total: number,
    //excludes declined amount
    refundedTotal: number,
    refundPayments: RefundPaymentDto[],
    currency: string
}

export type RefundPaymentsDto = {
    id: string,
    type: string,
    attributes: RefundPaymentsAttributes
}

export default class RefundPayments implements Entity {
    private dto: RefundPaymentsDto

    constructor(dto: RefundPaymentsDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.type === "refund-payments"
    }

    getId(): string {
        return this.dto.id
    }

    getRefundPayments() : RefundPaymentsDto {
        return this.dto
    }

    getRefundedPayments() : RefundPayment[] {
        return this.dto.attributes.refundPayments.map(refundPayment => new RefundPayment(refundPayment))
    }

    getCurrency(): string {
        return this.dto.attributes.currency
    }

    getTotal(): number {
        return this.dto.attributes.total
    }

    getRefundedTotal(): number {
        return this.dto.attributes.refundedTotal
    }
}


// WEBPACK FOOTER //
// ./src/state/payment/refund/RefundPayments.ts